export const ADDRESS_BOOK_TEXT = {
  'address-book.title': {
    'en-GB': 'Address Book | Moonpig',
    'nl-NL': 'Adresboek | Greetz',
  },
  'address-book.heading': {
    'en-GB': 'Address Book',
    'nl-NL': 'Adresboek',
  },
  'address-book.send-to-me': {
    'en-GB': 'Send to me',
    'nl-NL': 'Naar je eigen adres',
  },
  'address-book.send-to-them': {
    'en-GB': 'Send to them',
    'nl-NL': 'Naar hen versturen',
  },
  'address-book.add-a-new-recipient': {
    'en-GB': 'Add a New Recipient',
    'nl-NL': 'Een nieuwe ontvanger toevoegen ',
  },
  'address-book.spare-envelope': {
    'en-GB':
      'We’ll <strong>send it to you first</strong>, with\n<strong> a spare envelope</strong> for each card.',
    'nl-NL':
      'We <strong>sturen het eerst naar jou</strong>, samen met voor elke kaart een <strong>extra envelop</strong>.',
  },
  'address-book.send-to-their-door': {
    'en-GB': 'We’ll send it straight to their door',
    'nl-NL': 'We sturen het rechtstreeks naar hun adres.',
  },
  // This translation is copied in addresses.local.ts
  'address-book.no_addresses_message': {
    'en-GB': 'No addresses saved yet.',
    'nl-NL': 'Nog geen adressen opgeslagen.',
  },
  'address-book.error': {
    'en-GB': 'Oops, something went wrong.',
    'nl-NL': 'Oeps, er is iets misgegaan.',
  },
  'address-book.bulk_upload.upload_cta': {
    'en-GB': 'Bulk Add Addresses',
    'nl-NL': 'Upload je eigen CSV-bestand',
  },
  'address-book.back_to_basket': {
    'en-GB': 'Back to Basket',
    'nl-NL': 'Terug naar winkelmandje',
  },
  'address-book.option_edit_address': {
    'en-GB': 'Edit',
    'nl-NL': 'Bewerken',
  },
  'address-book.option_delete_address': {
    'en-GB': 'Delete',
    'nl-NL': 'Verwijderen',
  },
}
